export default {
  SET_MATCH_PARAMS(state, params) {
    state.aiMatchParams.size = params.size ? params.size : 200
    state.aiMatchParams.minFollowers = params.minFollowers ? params.minFollowers : 500
    state.aiMatchParams.postDate = params.postDate ? params.postDate : ''
  },
  TOGGLE_LOADING(state) {
    state.callingAPI = !state.callingAPI
  },
  TOGGLE_SEARCHING(state) {
    state.searching = state.searching === '' ? 'loading' : ''
  },
  SET_USER(state, user) {
    state.user = user
  },
  SET_FACEBOOK_DATA(state, facebook) {
    state.facebook = facebook
  },
  SET_AVATAR(state, profilePicture) {
    state.user.profilePicture = profilePicture
    let user = JSON.parse(localStorage.getItem('user'))
    if (user !== undefined) {
      user.profilePicture = profilePicture
      localStorage.setItem('user', JSON.stringify(user))
    }
  },
  SET_TOKEN(state, token) {
    state.token = token
  },
  SET_GLOBAL_CONFIG(state, config) {
    state.globalConfig = config
  },
  REMOVE_GLOBAL_CONFIG(state, config) {
    state.globalConfig = null
  },
  REMOVE_USER(state) {
    state.user = null
  },
  REMOVE_FACEBOOK_DATA(state) {
    state.facebook = null
  },
  REMOVE_TOKEN(state) {
    state.token = null
  },
  SET_COMPANIES(state, companyList) {
    state.cache.companyList = {
      data: companyList,
      lastUpdate: Date.now()
    }
  },
  SET_CLIENTS(state, clientList) {
    state.cache.clientList = {
      data: clientList,
      lastUpdate: Date.now()
    }
  },
  SET_CAMPAIGNS(state, campaignData) {
    state.cache.campaignList[campaignData.campaignStatus] = {
      data: campaignData.data,
      lastUpdate: Date.now()
    }
  },
  SET_CAMPAIGNVERTICALS(state, campaignVerticalList) {
    state.cache.campaignVerticalList = {
      data: campaignVerticalList,
      lastUpdate: Date.now()
    }
  },
  SET_INFLUENCERS(state, influencerList) {
    state.cache.influencerList = {
      data: influencerList,
      lastUpdate: Date.now()
    }
  },
  CLEAR_CACHE(state) {
    state.cache = {
      companyList: {
        data: null,
        lastUpdate: null
      },
      clientList: {
        data: null,
        lastUpdate: null
      },
      campaignList: {},
      influencerList: {
        data: null,
        lastUpdate: null
      }
    }
  },
  SET_NOTIFICATIONS(state, notificationData) {
    state.userInfo.notifications = notificationData
  },
  SET_USER_PLATFORMS(state, infInfo) {
    state.userPlatforms = []
    state.showActivePlatform = null
    state.activePlatform = null
    if (infInfo.instagram && infInfo.instagram.instagramHandle) {
      state.userPlatforms.push({
        handle: '@' + infInfo.instagram.instagramHandle,
        platform: 'instagram',
        icon: 'mdi-instagram'
      })
    }
    if (infInfo.facebook && infInfo.facebook.handle) {
      state.userPlatforms.push({
        handle: '@' + infInfo.facebook.handle,
        platform: 'facebook',
        icon: 'mdi-facebook'
      })
    }
    if (infInfo.tiktok && infInfo.tiktok.tiktokHandle) {
      state.userPlatforms.push({
        handle: '@' + infInfo.tiktok.tiktokHandle,
        platform: 'tiktok',
        imgIcon: '/static/img/tiktok-32.png'
      })
    }
    if (infInfo.youtube && (infInfo.youtube.youtubeHandle || infInfo.youtube.youtubeCustomName)) {
      state.userPlatforms.push({
        handle: '@' + (infInfo.youtube.youtubeHandle || infInfo.youtube.youtubeCustomName),
        platform: 'youtube',
        icon: 'mdi-youtube'
      })
    }
    if (infInfo.xiaohongshu && (infInfo.xiaohongshu.xhsFullname || infInfo.xiaohongshu.xhsHandle)) {
      state.userPlatforms.push({
        handle: '@' + (infInfo.xiaohongshu.xhsFullname || infInfo.xiaohongshu.xhsHandle),
        platform: 'xiaohongshu',
        icon: ''
      })
    }
    if (infInfo.linkedin && infInfo.linkedin.linkedinHandle) {
      state.userPlatforms.push({
        handle: '@' + infInfo.linkedin.linkedinHandle,
        platform: 'linkedin',
        icon: 'mdi-linkedin'
      })
    }
    if (infInfo.twitter && infInfo.twitter.twitterHandle) {
      state.userPlatforms.push({
        handle: '@' + infInfo.twitter.twitterHandle,
        platform: 'twitter',
        imgIcon: '/static/img/x-logo.svg'
      })
    }
    const requestedActivePlatform = String(infInfo.activePlatform || '').toLowerCase() === 'x'
      ? 'twitter'
      : String(infInfo.activePlatform || '').toLowerCase()
    state.showActivePlatform = state.userPlatforms.find(p => p.platform === requestedActivePlatform) || state.userPlatforms[0] || null
    if (state.showActivePlatform) state.activePlatform = state.showActivePlatform.platform
  },
  REMOVE_ACTIVE_PLATFORM(state) {
    state.showActivePlatform = null
  }
}



// WEBPACK FOOTER //
// ./src/store/mutations.js